import { render } from "./ActivityPage.vue?vue&type=template&id=253ac7cb&scoped=true&ts=true"
import script from "./ActivityPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityPage.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityPage.vue?vue&type=style&index=0&id=253ac7cb&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253ac7cb"],['__file',"src/views/me/ActivityPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "253ac7cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('253ac7cb', __exports__)) {
    console.log('reload')
    api.reload('253ac7cb', __exports__)
  }
  
  module.hot.accept("./ActivityPage.vue?vue&type=template&id=253ac7cb&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('253ac7cb', render)
  })

}


export default __exports__